import React from 'react';
import { css } from '@emotion/css';
import OrganizationModel from '../../../models/organizations/api/OrganizationModel';
import { dark_grey_blue, pale_grey, cool_grey, ocean_blue, color_shades_lighter } from '../../../constants/colors';
import { Link } from 'react-router-dom';
import HorizontalSeparator from '../../../components/structure/HorizontalSeparator';
import ToggleIndicator from '../../../components/general/ToggleIndicator';
import Scrollbars from 'react-custom-scrollbars';

interface OrganizationsMenuItemProps {
    currentOrganization: OrganizationModel
    organizations: OrganizationModel[]
    onOrganizationSelected: (org: OrganizationModel) => void
}
class OrganizationsMenuItem extends React.Component<OrganizationsMenuItemProps> {
    render() {
        return (
            <div className={containerStyle}>
                <div className={listContainerStyle}>
                    <div className={listInnerContainerStyle}>
                        {this.props.organizations.length > 0 ? this.props.organizations.map((org, index) =>
                            <div key={org.id}>
                                <Link to="/v" className={`${listItemStyle} ${org.id == this.props.currentOrganization.id ? currentOrgStyle : ''}`} onClick={() => this.props.onOrganizationSelected(org)}>
                                    <p>{org.name}</p>
                                </Link>
                                {index !== this.props.organizations.length - 1 ? <HorizontalSeparator /> : null}
                            </div>
                        ) : <p className={emptyLabelStyle}>This is where you'll see other organizations you're a member of.</p>}
                    </div>
                </div>
            </div>
        )
    }
}

const listContainerStyle = css`
    padding: 32px;
    background: ${color_shades_lighter};
`

const listInnerContainerStyle = css`
border-radius: 8px;
background-color: white;
border: solid 1px #cccccc;
`

const listItemStyle = css`
    height: 48px;
    font-family: Muli;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: ${dark_grey_blue};
    display: flex;
    align-items: center;
    p {
        margin-right: 22px;
        margin-left: auto;
    }

    &:hover {
        color: ${ocean_blue};
    }
`

const emptyLabelStyle = css`
    height: 48px;
    font-family: Muli;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: ${dark_grey_blue};
    display: flex;
    align-items: center;
    padding: 8px;
`

const currentOrgStyle = css`
    color: ${ocean_blue};
`
const textContainerStyle = css`
    display: flex;
    flex-direction: column;
    align-items: right;
    justify-content: center;
    margin-right: 19;
    margin-left: auto;
    p,span {
        text-align: right;
    }
`
const containerStyle = css`
    overflow: hidden;
    border-radius: 0 0 20px 20px;
    margin-bottom: 124px;
`

export default OrganizationsMenuItem;